import React, { useState, useEffect } from 'react';
import { View, ScrollView, StyleSheet, TouchableOpacity } from 'react-native';
import { TextInput, Button, Text, Switch, useTheme, HelperText, Snackbar, ActivityIndicator } from 'react-native-paper';
import { createCategory, updateCategory } from '../../../api/adminAPI';

const CategoryFormScreen = ({ route, navigation }) => {
  const theme = useTheme();
  const { category } = route.params || {};
  const isEditMode = !!category;
  
  // Form state
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isActive, setIsActive] = useState(true);

  // UI state
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  
  // Düzenleme modunda form alanlarını doldur
  useEffect(() => {
    if (isEditMode && category) {
      setName(category.name || '');
      setDescription(category.description || '');
      setIsActive(category.is_active === undefined ? true : !!category.is_active);
    }
  }, [isEditMode, category]);

  // Form doğrulama
  const validateForm = () => {
    const newErrors = {};
    
    if (!name.trim()) {
      newErrors.name = 'Kategori adı gereklidir';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  // Kategori kaydetme/güncelleme işlemi
  const handleSave = async () => {
    if (!validateForm()) return;
    
    setLoading(true);
    
    try {
      const categoryData = {
        name,
        description,
        is_active: isActive
      };
      
      let response;
      
      if (isEditMode) {
        response = await updateCategory(category.id, categoryData);
      } else {
        response = await createCategory(categoryData);
      }
      
      if (response.success) {
        setSnackbarMessage(isEditMode ? 'Kategori güncellendi' : 'Yeni kategori oluşturuldu');
        setSnackbarVisible(true);
        
        // Kısa bir süre bekleyip listeye dön
        setTimeout(() => {
          navigation.goBack();
        }, 1500);
      } else {
        setSnackbarMessage(response.message || 'Bir hata oluştu');
        setSnackbarVisible(true);
      }
    } catch (error) {
      console.error('Error saving category:', error);
      setSnackbarMessage(error.message || 'Kategori kaydedilirken bir hata oluştu');
      setSnackbarVisible(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ScrollView style={styles.container}>
      <View style={styles.formContainer}>
        {/* Kategori İsmi */}
        <TextInput
          label="Kategori Adı *"
          value={name}
          onChangeText={setName}
          mode="outlined"
          style={styles.input}
          error={!!errors.name}
          disabled={loading}
          outlineColor="rgb(125, 76, 236)"
          activeOutlineColor="rgb(125, 76, 236)"
        />
        {errors.name && <HelperText type="error">{errors.name}</HelperText>}
        
        {/* Açıklama */}
        <TextInput
          label="Açıklama"
          value={description}
          onChangeText={setDescription}
          mode="outlined"
          multiline
          numberOfLines={3}
          style={styles.input}
          disabled={loading}
          outlineColor="rgb(125, 76, 236)"
          activeOutlineColor="rgb(125, 76, 236)"
        />
        
        {/* 
        <View style={styles.switchContainer}>
          <Text style={{color: 'rgb(125, 76, 236)', fontWeight: 'bold'}}>Aktif</Text>
          <Switch
            value={isActive}
            onValueChange={setIsActive}
            disabled={loading}
            color="rgb(125, 76, 236)"
          />
        </View>
        Aktif/Pasif Durumu */}
        
        {/* Kaydet Butonu */}
        <Button
          mode="contained"
          onPress={handleSave}
          style={[styles.button, {backgroundColor: 'rgb(125, 76, 236)'}]}
          loading={loading}
          disabled={loading}
          labelStyle={{color: 'white', fontWeight: 'bold'}}
        >
          <Text style={{color: 'white'}}>{isEditMode ? 'Güncelle' : 'Kategori Oluştur'}</Text>
        </Button>
        
        {/* İptal Butonu */}
        <Button
          mode="outlined"
          onPress={() => navigation.goBack()}
          style={[styles.button, {borderColor: 'rgb(125, 76, 236)'}]}
          disabled={loading}
          textColor="rgb(125, 76, 236)"
        >
          İptal
        </Button>
      </View>
      
      {/* Snackbar */}
      <Snackbar
        visible={snackbarVisible}
        onDismiss={() => setSnackbarVisible(false)}
        duration={3000}
        style={{backgroundColor: 'rgb(125, 76, 236)'}}
        theme={{colors: {surface: '#fff'}}}
        action={{
          label: 'Kapat',
          onPress: () => setSnackbarVisible(false),
          color: '#fff'
        }}
      >
        {snackbarMessage}
      </Snackbar>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgb(232, 162, 249)',
  },
  formContainer: {
    padding: 16,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: 8,
    margin: 8,
  },
  input: {
    marginBottom: 12,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
  },
  switchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginVertical: 16,
    paddingHorizontal: 8,
    backgroundColor: 'rgba(125, 76, 236, 0.1)',
    padding: 12,
    borderRadius: 8,
  },
  button: {
    marginVertical: 8,
  },
});

export default CategoryFormScreen;
